import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  bottom: -20%;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: -20%;
  z-index: ${({ theme }) => theme.zIndex.modalDialog};
`;

const ChildrenWrapper = styled.div`
  background-color: white;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  box-shadow: 0px 1px 16px rgba(0,0,0,0.5);
  margin: ${({ theme }) => theme.spacing * 2}px;
  max-width: ${({ theme }) => theme.breakpoints.md}px;
  overflow: auto;
  max-height:80vh;
  width: 100%;
`;

const BodyElement = document.body;

const ModalDialog = ({ className, children, onCloseCb }) => {
  const classes = ['ModalDialog'];
  if (className) classes.push(className);

  function handleClick(e) {
    e.stopPropagation();
  }

  return ReactDOM.createPortal(
    <Wrapper className={classes.join(' ')} onClick={onCloseCb}>
      <ChildrenWrapper onClick={handleClick}>
        {children}
      </ChildrenWrapper>
    </Wrapper>,
    BodyElement,
  );
};

ModalDialog.displayName = 'ModalDialog';

ModalDialog.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ModalDialog.defaultProps = {
  className: null,
};

export default ModalDialog;
